export default "__VITE_ASSET__DDNWmUM0__"